import React, {useState} from 'react';
import MensajesEspañol from './../lang/es-MX.json';
import MensajesIngles from './../lang/en-US.json';
import {IntlProvider} from 'react-intl';

const langContext = React.createContext();

const LangProvider = ({children}) => {
	let localePorDefecto;
	let mensajesPorDefecto;
	const lang = localStorage.getItem('lang');

	if(lang){
		localePorDefecto = lang

		if(lang === 'es'){
			mensajesPorDefecto = MensajesEspañol;
			
		}  else if(lang === 'es-es'){
			mensajesPorDefecto = MensajesEspañol;
			
		}  else if(lang === 'es-ar'){
			mensajesPorDefecto = MensajesEspañol;
			
		}  else if(lang === 'es-419'){
			mensajesPorDefecto = MensajesEspañol;
			
		}   else if(lang === 'es-MX'){
			mensajesPorDefecto = MensajesEspañol;
			
		}  else if(lang === 'en-US'){
			mensajesPorDefecto = MensajesIngles
			
		} else {
			localePorDefecto = 'es-MX'
			mensajesPorDefecto = MensajesEspañol
		}
	}

	const [mensajes, establecerMensajes] = useState(mensajesPorDefecto);
	const [locale, establecerLocale] = useState(localePorDefecto);

	const establecerLenguaje = (lenguaje) => {
		switch (lenguaje){
						
			case 'es':
				establecerMensajes(MensajesEspañol);
				establecerLocale('es-MX');
				localStorage.setItem('lang', 'es-MX');
				break;
			case 'es-es':
				establecerMensajes(MensajesEspañol);
				establecerLocale('es-MX');
				localStorage.setItem('lang', 'es-MX');
				break;
            case 'es-ar':
				establecerMensajes(MensajesEspañol);
				establecerLocale('es-MX');
				localStorage.setItem('lang', 'es-MX');
				break;
            case 'es-419':
				establecerMensajes(MensajesEspañol);
				establecerLocale('es-MX');
				localStorage.setItem('lang', 'es-MX');
				break;				
			case 'es-MX':
				establecerMensajes(MensajesEspañol);
				establecerLocale('es-MX');
				localStorage.setItem('lang', 'es-MX');
				break;
			case 'en-US':
				establecerMensajes(MensajesIngles);
				establecerLocale('en-US');
				localStorage.setItem('lang', 'en-US');
				break;
			default:
				establecerMensajes(MensajesIngles);
				establecerLocale('es-ar');
				localStorage.setItem('lang', 'es-ar');
		}
	}

	return (
		<langContext.Provider value={{establecerLenguaje: establecerLenguaje}}>
			<IntlProvider locale={locale} messages={mensajes}>
				{children}
			</IntlProvider>
		</langContext.Provider>
	);
}
 
export {LangProvider, langContext};